(function() {
    function funcReady() {
        $('.KRP1201').buildCommonUI();
        
        pdpSetProductTabScroll();

        var clearTime = null;
        var seconds = 300;
        $(window).on('resize', function() {
            pdpSetProductTabScroll();
            clearTimeout(clearTime);
            clearTime = setTimeout(function() {
                pdpSetProductTabScroll();
            }, seconds);
        });
    }

    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'RENTAL', name: 'KRP1201', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP1201')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP1201')) return false;
        funcReady();
    });

    /* PDP SET 상품 탭 */
    function pdpSetProductTabScroll() {
        var setProdTab = $('.set-prod-tabmenu-wrap');
        var btnExpanded = setProdTab.find('.btn-expand');
        var tabMenuSlider = setProdTab.children('.ui_smooth_scroll');
        var tabW = tabMenuSlider.width();
        var mobDevice = 768;

        if($(window).width() < mobDevice) {
            var item = tabMenuSlider.children('ul').children('li');
            var itemWidth = 0;
            item.each(function() {
                itemWidth += $(this).width();
            });
            if(itemWidth + 64 < tabW) {
                btnExpanded.hide();
            } else {
                btnExpanded.show();
            }
            btnExpanded.on('click', function() {
                var _this = $(this);
                var tabMenuWrap = _this.parent();
                if(tabMenuWrap.hasClass('expanded')) {
                    tabMenuWrap.removeClass('expanded');
                    tabMenuSlider.vcSmoothScroll('refresh');
                    setProdTab.find('.tab-menu-list').css({width: setProdTab.find('.tab-menu-list').width() + 2});
                } else {
                    tabMenuWrap.addClass('expanded');
                    tabMenuSlider.vcSmoothScroll('destroy');
                }
            });
        }
    }
})();